const TIMESTAMP_TO_TIME = 1000;

export const normalizeDate = (timestamp: number) => {
  const date = new Date(timestamp * TIMESTAMP_TO_TIME);
  const publishDate = date.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
  const publishTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });

  return { publishDate, publishTime };
};
